(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kevora-adv05"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ka-reading-progress')){customElements.define('ka-reading-progress',class extends HTMLElement{connectedCallback(){this.root=this.closest('.ka-page');this.fill=this.querySelector('.ka-progress-fill');this.track=this.querySelector('.ka-progress-track');if(!this.root||!this.fill||!this.track)return;this.update=()=>{const r=this.root.getBoundingClientRect(),span=Math.max(0,r.height-innerHeight),p=span?Math.min(1,Math.max(0,-r.top/span)):1;this.fill.style.transform=`scaleX(${p})`;this.track.setAttribute('aria-valuenow',Math.round(p*100))};this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};window.addEventListener('scroll',this.schedule,{passive:true});window.addEventListener('resize',this.schedule);this.observer=new ResizeObserver(this.schedule);this.observer.observe(this.root);this.schedule()}disconnectedCallback(){window.removeEventListener('scroll',this.schedule);window.removeEventListener('resize',this.schedule);this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame)}})}
if(!customElements.get('ka-mobile-sticky')){customElements.define('ka-mobile-sticky',class extends HTMLElement{connectedCallback(){this.root=this.closest('.ka-page');this.trigger=parseFloat(this.dataset.trigger||'.2');if(!this.root)return;this.update=()=>{const r=this.root.getBoundingClientRect(),distance=Math.max(0,-r.top),range=Math.max(1,r.height-innerHeight),visible=innerWidth<=749&&distance/range>=this.trigger;this.classList.toggle('is-visible',visible);this.setAttribute('aria-hidden',visible?'false':'true')};this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})};window.addEventListener('scroll',this.schedule,{passive:true});window.addEventListener('resize',this.schedule);this.observer=new ResizeObserver(this.schedule);this.observer.observe(this.root);this.schedule()}disconnectedCallback(){window.removeEventListener('scroll',this.schedule);window.removeEventListener('resize',this.schedule);this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame)}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kevora-editorial"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('kv-reading-progress')) return;
  class KvReadingProgress extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      this._root = this.closest('.kv-landing');
      this._track = this.querySelector('.kv-progress-track');
      this._fill = this.querySelector('.kv-progress-fill');
      this._article = this._root?.querySelector('.kv-article');
      if (!this._root || !this._track || !this._fill || !this._article) return;
      this._schedule = () => {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => { this._frame = 0; this._update(); });
      };
      const signal = this._controller.signal;
      window.addEventListener('scroll', this._schedule, { passive: true, signal });
      window.addEventListener('resize', this._schedule, { passive: true, signal });
      window.addEventListener('pageshow', this._schedule, { signal });
      this._root.addEventListener('load', this._schedule, { capture: true, signal });
      this._root.addEventListener('loadedmetadata', this._schedule, { capture: true, signal });
      if (window.ResizeObserver) {
        this._observer = new ResizeObserver(this._schedule);
        this._observer.observe(this._root);
        this._observer.observe(this._article);
      }
      document.fonts?.ready.then(() => { if (this.isConnected) this._schedule(); });
      this._schedule();
    }
    _update() {
      const start = this._root.getBoundingClientRect().top + window.scrollY;
      const bottom = this._root.getBoundingClientRect().bottom + window.scrollY;
      const span = Math.max(0, bottom - window.innerHeight - start);
      const fraction = span > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / span)) : 1;
      this._fill.style.transform = `scaleX(${fraction})`;
      this._track.setAttribute('aria-valuenow', String(Math.round(fraction * 100)));
      this.classList.toggle('kv-progress-complete', fraction >= 0.999);
      const stickyTrigger = Number.parseFloat(this._root.dataset.stickyTrigger || '0.4');
      this._root.classList.toggle('kv-sticky-visible', fraction >= stickyTrigger);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
  }
  customElements.define('kv-reading-progress', KvReadingProgress);
})();


  } catch(e) { console.error(e); }
})();
})();
